export default __webpack_public_path__ + "static/media/flyingRock1.741d572c.webp";